function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#201D1A",
  d: "M21.6 2.443H12L10.308.7C9.852.249 9.24 0 8.604 0H2.4C1.08 0 0 1.069 0 2.375v14.25C0 17.931 1.08 19 2.4 19h19.2c1.32 0 2.4-1.069 2.4-2.375V4.75c0-1.306-1.08-2.307-2.4-2.307z",
  transform: "translate(0 2)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.738 5.007c2.758-.145 5.11 1.974 5.255 4.73.145 2.758-1.973 5.112-4.731 5.256-2.758.145-5.11-1.974-5.255-4.732-.145-2.757 1.974-5.11 4.731-5.254zM12 8.033c-1.087 0-1.968.88-1.968 1.966 0 1.088.881 1.968 1.968 1.968s1.967-.88 1.967-1.968c0-1.086-.88-1.966-1.967-1.966zm0 .3c.919 0 1.667.748 1.667 1.667 0 .92-.748 1.667-1.667 1.667-.92 0-1.667-.748-1.667-1.667S11.081 8.333 12 8.333zm0 .193c-.813 0-1.474.661-1.474 1.475 0 .812.66 1.473 1.474 1.473.813 0 1.475-.66 1.475-1.473 0-.814-.662-1.475-1.475-1.475zm0 .64c.46 0 .833.374.833.834 0 .46-.373.833-.833.833-.46 0-.833-.374-.833-.833 0-.46.373-.833.833-.833zm0 .202c.348 0 .632.283.632.632 0 .349-.284.632-.632.632-.349 0-.632-.283-.632-.632 0-.349.283-.632.632-.632zm.536-3.826l.086.006c.395.048.677.407.629.803-.011.094-.042.185-.088.268l-.68 1.2-.078-.03c-.128-.04-.248-.038-.307-.034l-.036.003-.282-1.284-.015-.104c-.03-.376.22-.727.6-.81l.085-.014c.057-.006.115-.005.172.002z",
  transform: "translate(0 2)"
});

var SvgMasterFolder = function SvgMasterFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMasterFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/masterFolder.722d58d3.svg";
export { ForwardRef as ReactComponent };